import {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";

import api from "@/services/api";

const ExamFeeContext = createContext(null);

export function ExamFeeProvider({ children }) {
  const [examFee, setExamFee] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchExamFee = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const response = await api.get("/exam-fee");

      const amount = response?.data?.data?.amount;

      if (amount !== undefined && amount !== null) {
        setExamFee(Number(amount));
      } else {
        setExamFee(null);
      }
    } catch (err) {
      console.error(
        "Failed to load exam fee:",
        err?.response?.data || err
      );

      setExamFee(null);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchExamFee();
  }, [fetchExamFee]);

  return (
    <ExamFeeContext.Provider
      value={{
        examFee,
        loading,
        error,
        refreshExamFee: fetchExamFee,
      }}
    >
      {children}
    </ExamFeeContext.Provider>
  );
}

export function useExamFee() {
  const context = useContext(ExamFeeContext);

  if (!context) {
    throw new Error(
      "useExamFee must be used inside ExamFeeProvider"
    );
  }

  return context;
}